import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const DragAndDropGrid = ({ onDoubleClick, items, handleItemChange, maximumHeight }) => {
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        "border": isDragging ? "2px solid black" : "none",
        borderRadius: 8,
        padding: 6,
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver) => ({
        padding: 8,
        width: 200,
        maxHeight: maximumHeight ? maximumHeight : 500, /* Set the maximum height for the div */
        overflowY: 'auto'  /* Enable vertical scrolling when content exceeds the max height */
    });


    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
          return;
        }

        handleItemChange(reorder(items, result.source.index, result.destination.index));
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {items && items.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                        onDoubleClick={() => {
                                            if(onDoubleClick) {
                                                onDoubleClick(index);
                                            }
                                        }}
                                    >
                                        {item.element}
                                        
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};
export default DragAndDropGrid;
